/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Open_Manager_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Open voice manager" |
*
* @param {Voices_Open_Manager_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_open_manager_aria_label = /** @type {((inputs?: Voices_Open_Manager_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Open_Manager_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le gestionnaire de voix")
	if (locale === "de") return /** @type {LocalizedString} */ ("Open Voice Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri il gestore vocale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открытый голосовой менеджер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrador de voz abierto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开放式语音管理器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オープンボイスマネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओपन वॉइस मैनेजर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra o gerenciador de voz")
	return /** @type {LocalizedString} */ ("Open voice manager")
});